var map = {
	"./symbol_0.png": "69d9",
	"./symbol_1.png": "bd23",
	"./symbol_2.png": "6bb97",
	"./symbol_3.png": "1755",
	"./symbol_4.png": "47af",
	"./symbol_5.png": "4a15",
	"./symbol_6.png": "6cb6",
	"./symbol_7.png": "cc79",
	"./symbol_8.png": "9274"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bd6";